import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import styles from './radioGroup.css';
import InputRadio from './inputRadio';

const RadioGroup = ({
  name,
  createOnChange,
  inputs,
  currentValue,
  className,
}) => (
  <div className={classNames(className, styles.group)}>
    {inputs.map(({ value, label }, idx) => (
      <InputRadio
        key={value}
        value={value}
        label={label}
        name={name}
        id={`${name}${idx}`}
        checked={value === currentValue}
        className={classNames({ [styles.selected]: value === currentValue })}
        onChange={createOnChange(name)}
      />
    ))}
  </div>
);

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  createOnChange: PropTypes.func.isRequired,
  currentValue: PropTypes.string.isRequired,
  inputs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  className: PropTypes.string,
};

RadioGroup.defaultProps = {
  className: '',
};

export default withStyles(styles)(RadioGroup);
